<template>
    <section class="discussion-guest d-flex flex-column gap-2" 
             tabindex="0"
             @keyup.esc="() => searchValue = ''" >
        <section v-if="isLock === false" class="d-flex flex-column gap-2">
            <section class="d-flex flex-row justify-content-center flex-wrap gap-2">
                <SearchInputTextComponent ref="searchPerson"
                                          v-model="searchValue"
                                          :placeholder="$t('com.file.discussion-quest-list.find-person')"
                                          :withButton="false" />
                <AddNewQuestButton @enableAddNewGuestModal="$store.commit('showAddNewGuestModal')" />
            </section>

            <perfect-scrollbar class="discussion-guests-list d-flex flex-row flex-wrap gap-2 justify-content-center align-content-start">
                <DiscussionQuestItem v-for="(item, key) in suggestQuestList"
                                     :key="key" :item="item"
                                     @addParticipantToRequestSpeechList="addParticipantToRequestSpeechList"
                                     @giveParticipantSpeech="giveParticipantSpeech"
                                     @removeParticipantFromFavorite="addParticipantToFavorite"
                                     @addParticipantToFavorite="addParticipantToFavorite"
                                     @removeParticipant="removeParticipant"
                                     @addParticipantToPriority="addParticipantToPriority"
                                     @removeParticipantFromPriority="removeParticipantFromPriority" />
            </perfect-scrollbar>
        </section>
        <section class="d-flex flex-row justify-content-center flex-wrap gap-2 px-3 text-center" v-else>
            <h2 style="color: #000;">{{$t('com.file.discussion-quest-list.no-discuss-mode')}} <br />{{$t('com.file.discussion-quest-list.or-no-interactive-mode')}}</h2>
        </section>
    </section>
</template>
<script charset="utf-8">
    // services
    import eSesjaInteractiveService from "../../../../services/esesja.interactive.service";
    import userService from "../../../../services/user.service";
    import interactiveService from "../../../../services/interactive.service";
    import { encryptStorage } from '../../../../services/encrypt.service';
    import alertsHelper from "../../../../helpers/alerts.helper";
    import sessionService from "../../../../services/session.service";

    // components
    import DiscussionQuestItem from "./DiscussionQuestItem.vue";
    import AddNewQuestButton from "./AddNewQuestButton.vue";
    import SearchInputTextComponent from "../../../BasicControls/SearchInputTextComponent.vue";



    export default {
        name: "DiscussionQuestList",
        components: {
            DiscussionQuestItem,
            SearchInputTextComponent,
            AddNewQuestButton,
        },
        computed: {
            sessionId() {
                return parseInt(this.$route.params.sessionId);
            },
            isDiscussionModule() {
                if (this.discussionModule == 1)
                    return true;

                return false;
            },

            isLock() {
                return (this.sessionStatus === false || this.isDiscussionModule === false);
            }
        },
        data() {
            return {
                internalAvailableQuestList: [],
                suggestQuestList: [],
                currentRequestList: [],
                currentActiveSpeech: {
                    userId: 0,
                    discussionId: -1,
                },
                searchValue: "",
                isLoading: false,
                discussionModule: encryptStorage.getItem('modules').d,
                sessionStatus: false,
            }
        },
        watch: {
            searchValue: {
                immediate: true,
                handler(val) {
                    try {
                        this.$store.commit("showLoader");
                        if (val === '' || val === "") {
                            this.suggestQuestList = this.internalAvailableQuestList
                        }
                        else {
                            this.suggestQuestList = this.internalAvailableQuestList.map(item => { return { ...item } });
                            this.suggestQuestList = Array.from(this.suggestQuestList.filter(item => {
                                if (item.queryString.indexOf(val.toLowerCase()) !== -1) {
                                    if (item.name !== undefined && item.name !== null)
                                        item.name = item.name.replace(new RegExp(val, 'gi'), "<span class='highlite'>$&</span>");

                                    if (item.surname !== undefined && item.surname !== null)
                                        item.surname = item.surname.replace(new RegExp(val, 'gi'), "<span class='highlite'>$&</span>");
                                    return true;
                                }

                                return false;
                            }));
                        }
                    }
                    finally {
                        this.$store.commit("hideLoader");
                    }
                },
            },
        },
        async mounted() {
            try {
                if (this.isDiscussionModule === false) {
                    return;
                }
                this.$store.commit("showLoader");
                await this.internalFetchSessionInteractiveState();
                await this.internalConnectToInteractive();
                await this.fetchGuestLists();
                await this.fetchCurrentRequestLists();
                this.registerInteractiveEvents();
            }
            finally {
                this.$store.commit("hideLoader");
            }
        },
        unmounted() {
            this.unregisterInteractiveEvents();
        },
        methods: {
            async internalConnectToInteractive() {
                let responseRid = await userService.getCurrentRid();
                if (responseRid.status !== 200) {
                    throw await Promise.reject(responseRid);
                }

                await eSesjaInteractiveService.start(responseRid.data);
                await eSesjaInteractiveService.joinRoom(this.sessionId);
            },

            async fetchGuestLists() {
                let response = await interactiveService.getAvailableGuests();
                if (response.status !== 200) {
                    throw await Promise.reject(response);
                }
                this.prepareGuestData([...response.data])
            },

            async internalFetchSessionInteractiveState() {
                let response = await sessionService.isSessionInInteractive(this.sessionId);
                if (response.status !== 200) {
                    throw await Promise.reject(response);
                }
                this.sessionStatus = response.data;
            },

            async fetchCurrentRequestLists(){
                const response = await interactiveService.getCurrentRequestList(this.sessionId);
                if(response.status !== 200){
                    throw await Promise.reject(response);
                }
                this.currentRequestList = response.data.discussRequestList;
                this.currentActiveSpeech = response.data.currentSpeech;
            },

            prepareGuestData(data) {
                this.internalAvailableQuestList = data;
                this.internalAvailableQuestList = this.internalAvailableQuestList.map(item => {
                    let newItem = { ...item }
                    newItem.queryString = (`${item.name} ${item.surname}`).toLowerCase()
                    return newItem;
                });
                this.suggestQuestList = [...this.internalAvailableQuestList]
            },

            registerInteractiveEvents() {
                eSesjaInteractiveService.events.on("SignalRRefreshGuestLists", this.internalRefreshGuestLists)
                eSesjaInteractiveService.events.on("SignalRInteractiveSessionStateChange", this.internalInteractiveSessionState);
                eSesjaInteractiveService.events.on("SignalRUpdateDiscussionListAdmin", this.UpdateDiscussionListAdmin)
            },
            unregisterInteractiveEvents() {
                eSesjaInteractiveService.events.removeListener("SignalRRefreshGuestLists", this.internalRefreshGuestLists);
                eSesjaInteractiveService.events.removeListener("SignalRInteractiveSessionStateChange", this.internalInteractiveSessionState);
                eSesjaInteractiveService.events.removeListener("SignalRUpdateDiscussionListAdmin", this.UpdateDiscussionListAdmin)
            },

            internalRefreshGuestLists(data) {
                try {
                    this.prepareGuestData(data);
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },

            internalInteractiveSessionState(status) {
                this.sessionStatus = status;
            },

            UpdateDiscussionListAdmin(response){
                try{
                    this.currentRequestList = response.discussRequestList;
                    this.currentActiveSpeech = response.currentSpeech;
                }
                catch(e){
                    console.log(e);
                }
            },
            async addParticipantToRequestSpeechList(uid, type, requestType) {
                try {
                    if (this.isDiscussionModule === false) {
                        return;
                    }
                    if(this.currentRequestList.some(e => e.userId === uid && e.type.id === type) || (this.currentActiveSpeech && this.currentActiveSpeech.userId === uid)){
                        var t = this.$swal.mixin(alertsHelper.errorToastElement());
                        t.fire(alertsHelper.errorToastAlert(this.$t('com.validate-error.cant-add-participant-have-voice'), this.$t('com.global.error')));
                        return;
                    }
                    this.$store.commit("showLoader");
                    await eSesjaInteractiveService.addUserToRequestSpeech(uid, this.sessionId, type, requestType);
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },

            async giveParticipantSpeech(uid) {
                try {
                    if (this.isDiscussionModule === false) {
                        return;
                    }

                    if(this.currentActiveSpeech && this.currentActiveSpeech.userId === uid){
                        var t = this.$swal.mixin(alertsHelper.errorToastElement());
                        t.fire(alertsHelper.errorToastAlert(this.$t('com.validate-error.participant-have-voice'), this.$t('com.global.error')));
                        return;
                    }
                    this.$store.commit("showLoader");
                    await eSesjaInteractiveService.giveUserSpeech(parseInt(uid), -1, this.sessionId, 0);
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            async addParticipantToFavorite(uid) {
                try {
                    if (this.isDiscussionModule === false) {
                        return;
                    }
                    this.$store.commit("showLoader");
                    await eSesjaInteractiveService.addUserToFavourite(uid);
                }
                catch {
                    this.$store.commit("hideLoader");
                }
            },

            async removeParticipant(uid) {
                try {
                    if (this.isDiscussionModule === false) {
                        return;
                    }
                    this.$store.commit("showLoader");
                    await eSesjaInteractiveService.removeGuest(uid);
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            async addParticipantToPriority(uid) {
                if (this.isDiscussionModule === false) {
                    return;
                }
                try {
                    this.$store.commit("showLoader");
                    await eSesjaInteractiveService.addUserToPriority(uid);
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },

            async removeParticipantFromPriority(userId) {
                if (this.isDiscussionModule === false) {
                    return;
                }
                try {
                    this.$store.commit("showLoader");
                    await eSesjaInteractiveService.removeUserFromPriority(userId);
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
        }
    }
</script>
<style lang="scss">
    .discussion-guest {
        width: 100vw;
        .discussion-guests-list{
            position: relative;
            height: calc(100vh - 100px);

            .addquest-autocomplete-list-item{
                width: 286px;
            }
        }
    }
</style>